module.exports = __webpack_public_path__ + "img/diabetes-enter.00a85cf6.png";